export default __webpack_public_path__ + "static/Group 8-a30d5e4ff9119a42ef082fa3cce0c9c6.png";